import { useEffect, useState } from 'react';
import API from '../api';

const inp = (extra={}) => ({ width:'100%',padding:'10px 13px',border:'1.5px solid #E5E7EB',borderRadius:9,fontSize:'0.875rem',outline:'none',background:'#FAFAFA',boxSizing:'border-box',fontFamily:"'Golos Text',sans-serif",...extra });
const lbl = { display:'block',fontSize:'0.75rem',fontWeight:700,color:'#6B7280',marginBottom:5,textTransform:'uppercase',letterSpacing:'0.05em' };
const fmt = n => n ? Number(n).toLocaleString('ru-RU') : '—';

function Toast({ msg, type, onDone }) {
  useEffect(()=>{ const t=setTimeout(onDone,2800); return()=>clearTimeout(t); },[onDone]);
  const c = type==='success' ? { bg:'#F0FDF4',color:'#166534',border:'#BBF7D0' } : { bg:'#FEF2F2',color:'#991B1B',border:'#FECACA' };
  return <div style={{ position:'fixed',bottom:24,right:24,zIndex:9999,background:c.bg,color:c.color,border:`1px solid ${c.border}`,padding:'12px 20px',borderRadius:12,fontWeight:600,fontSize:'0.875rem',boxShadow:'0 4px 20px rgba(0,0,0,.1)' }}>{msg}</div>;
}

export default function AdminPricing() {
  const [plans, setPlans]     = useState([]);
  const [editing, setEditing] = useState(null);
  const [toast, setToast]     = useState(null);

  const load = () => API.get('/plans').then(r=>setPlans(r.data)).catch(()=>{});
  useEffect(()=>{ load(); },[]);

  const save = async () => {
    try {
      const payload = { ...editing, features: editing.featuresText.split('\n').map(f=>f.trim()).filter(Boolean), price: editing.price?Number(editing.price):null };
      await API.put(`/admin/plans/${editing.id}`, payload);
      load(); setEditing(null); setToast({ msg:'✓ Тариф сохранён',type:'success' });
    } catch { setToast({ msg:'Ошибка',type:'error' }); }
  };

  return (
    <div>
      {toast && <Toast msg={toast.msg} type={toast.type} onDone={()=>setToast(null)}/>}

      <div style={{ marginBottom:24 }}>
        <h1 style={{ fontFamily:"'Unbounded',sans-serif",fontWeight:800,fontSize:'1.4rem',color:'#06101e',margin:'0 0 4px' }}>Тарифы</h1>
        <p style={{ color:'#9CA3AF',fontSize:'0.875rem',margin:0 }}>Редактирование планов и цен</p>
      </div>

      <div style={{ display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(300px,1fr))',gap:14 }}>
        {plans.map(p => (
          <div key={p.id} style={{ background:'#fff',borderRadius:16,padding:'22px',boxShadow:'0 1px 8px rgba(0,0,0,.06)',border: p.popular ? '2px solid #00C2B8' : '1px solid #F0F0F0',position:'relative' }}>
            {p.popular && <div style={{ position:'absolute',top:14,right:14,background:'#00C2B8',color:'#06101e',fontSize:'0.65rem',fontWeight:800,padding:'3px 10px',borderRadius:20,textTransform:'uppercase',letterSpacing:'0.05em' }}>Популярный</div>}
            <div style={{ fontFamily:"'Unbounded',sans-serif",fontWeight:800,fontSize:'0.9rem',color:'#06101e',marginBottom:8 }}>{p.name}</div>
            <div style={{ fontFamily:"'Unbounded',sans-serif",fontSize:'1.8rem',fontWeight:900,color:'#06101e',lineHeight:1,marginBottom:4 }}>{fmt(p.price)}</div>
            <div style={{ color:'#9CA3AF',fontSize:'0.78rem',marginBottom:18 }}>{p.perLabel}</div>
            <ul style={{ listStyle:'none',padding:0,margin:'0 0 20px',display:'grid',gap:7 }}>
              {p.features?.map(f=>(
                <li key={f} style={{ display:'flex',gap:8,alignItems:'flex-start',fontSize:'0.82rem',color:'#374151' }}>
                  <span style={{ color:'#00C2B8',fontWeight:900,marginTop:1,flexShrink:0 }}>✓</span>{f}
                </li>
              ))}
            </ul>
            <button onClick={()=>setEditing({...p,featuresText:p.features?.join('\n')||''})} style={{ width:'100%',padding:'10px',background:'rgba(0,194,184,.08)',color:'#00C2B8',border:'none',borderRadius:9,fontFamily:"'Unbounded',sans-serif",fontWeight:700,fontSize:'0.78rem',cursor:'pointer' }}>Редактировать</button>
          </div>
        ))}
      </div>

      {/* Edit panel */}
      {editing && (
        <div style={{ position:'fixed',inset:0,background:'rgba(0,0,0,.4)',zIndex:999,display:'grid',placeItems:'center',padding:24 }} onClick={()=>setEditing(null)}>
          <div style={{ background:'#fff',borderRadius:18,padding:'28px',width:'100%',maxWidth:520,maxHeight:'90vh',overflowY:'auto',boxShadow:'0 20px 60px rgba(0,0,0,.15)' }} onClick={e=>e.stopPropagation()}>
            <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:22 }}>
              <h2 style={{ fontFamily:"'Unbounded',sans-serif",fontWeight:800,fontSize:'1.1rem',margin:0 }}>Тариф: {editing.name}</h2>
              <button onClick={()=>setEditing(null)} style={{ background:'#F5F5F5',border:'none',borderRadius:8,width:30,height:30,cursor:'pointer',fontSize:'1rem',display:'grid',placeItems:'center' }}>✕</button>
            </div>
            <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:12 }}>
              <div><label style={lbl}>Название</label><input value={editing.name} onChange={e=>setEditing(p=>({...p,name:e.target.value}))} style={inp()}/></div>
              <div><label style={lbl}>Цена (число)</label><input type="number" value={editing.price||''} onChange={e=>setEditing(p=>({...p,price:e.target.value}))} placeholder="149000" style={inp()}/></div>
            </div>
            <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:12 }}>
              <div><label style={lbl}>Отображение цены</label><input value={editing.priceLabel||''} onChange={e=>setEditing(p=>({...p,priceLabel:e.target.value}))} placeholder="149 000" style={inp()}/></div>
              <div><label style={lbl}>Подпись</label><input value={editing.perLabel||''} onChange={e=>setEditing(p=>({...p,perLabel:e.target.value}))} placeholder="сум / м²" style={inp()}/></div>
            </div>
            <div style={{ marginBottom:16 }}>
              <label style={lbl}>Опции (каждая с новой строки)</label>
              <textarea value={editing.featuresText||''} onChange={e=>setEditing(p=>({...p,featuresText:e.target.value}))} rows={7} style={{ ...inp(),resize:'vertical',lineHeight:1.7 }}/>
            </div>
            <label style={{ display:'flex',alignItems:'center',gap:8,cursor:'pointer',fontSize:'0.875rem',fontWeight:600,color:'#374151',marginBottom:20 }}>
              <input type="checkbox" checked={editing.popular} onChange={e=>setEditing(p=>({...p,popular:e.target.checked}))} style={{ width:16,height:16,accentColor:'#00C2B8' }}/>
              ⭐ Популярный тариф
            </label>
            <div style={{ display:'flex',gap:10 }}>
              <button onClick={save} style={{ flex:1,padding:'12px',background:'#00C2B8',color:'#06101e',border:'none',borderRadius:10,fontFamily:"'Unbounded',sans-serif",fontWeight:700,fontSize:'0.85rem',cursor:'pointer' }}>Сохранить</button>
              <button onClick={()=>setEditing(null)} style={{ padding:'12px 20px',background:'#F5F5F5',color:'#6B7280',border:'none',borderRadius:10,fontWeight:700,fontSize:'0.85rem',cursor:'pointer' }}>Отмена</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
